import { render, staticRenderFns } from "./AgentQueuesButton.vue?vue&type=template&id=92d6403a&scoped=true"
import script from "./AgentQueuesButton.vue?vue&type=script&lang=js"
export * from "./AgentQueuesButton.vue?vue&type=script&lang=js"
import style0 from "./AgentQueuesButton.vue?vue&type=style&index=0&id=92d6403a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d6403a",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QTooltip,QMenu,QBtn,QSpinner,QInput,QCheckbox,QSeparator});qInstall(component, 'directives', {ClosePopup});
